// HelpSafetyPage.tsx — /help/safety.
//
// The parts of the system that act on people rather than on posts. The text
// lives in core/data/help/safety.ts — authored once, rendered here and served
// to the app by GET /api/help/safety/ — so read that file for what the page
// says and why.
//
// Public: no sign-in gate, for the same reason /help/reporting has none.

import { helpSafety } from '@/core/data/help';
import { HelpDocumentView } from './HelpDocumentView';

export function HelpSafetyPage() {
  return <HelpDocumentView doc={helpSafety} />;
}
